<template>
  <div class="widget-content">
    <div class="dashboard">
      <AccordionHeadlineComponent :categories="categories" :type="type" />
      <div ref="crews" class="dashboard__crews widget">
        <div v-for="(crew, index) in crews" :key="crew.id">
          <AccordionCrewComponent :index="index" :crew="crew" :type="type" @goDashbord="dashboard" />
        </div>
        <div v-if="type === 'note'">
          <AccordionMarkHeadColumnComponent :title="$t('note.average')" :index="0" />
          <AccordionMarkHeadColumnComponent :title="$t('note.maximal_mark')" :index="1" />
          <AccordionMarkHeadColumnComponent :title="$t('note.minimal_mark')" :index="2" />
        </div>
      </div>
      <div ref="replies" class="dashboard__replies__wrapper" @scroll="scrollPosition(this.$refs.replies)">
        <div class="dashboard__replies">
          <div
            v-for="category in categories"
            :key="category.id"
            :class="
              'dashboard__replies__item on widget mb-0 category-' + category.id + (type === 'skill' ? ' -skill' : '')
            "
          >
            <div class="dashboard__replies__questionnaires">
              <AccordionColumnsComponent
                :category="category"
                :type="type"
                :crews="crews"
                :offset="crewTitleHeight"
                @manage="manage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionHeadlineComponent from "@/components/table/accordion/AccordionHeadlineComponent.vue";
import AccordionColumnsComponent from "@/components/table/accordion/AccordionColumnsComponent.vue";
import { mapActions } from "pinia";
import { useTriadStore } from "@/store/triad/triad";
import { dateFormatter } from "@/services/utilities/date-formatter";
import AccordionCrewComponent from "@/components/table/accordion/AccordionCrewComponent.vue";
import AccordionMarkHeadColumnComponent from "@/components/table/accordion/AccordionMarkHeadColumnComponent.vue";

export default {
  name: "AccordionTableComponent",
  components: {
    AccordionMarkHeadColumnComponent,
    AccordionCrewComponent,
    AccordionColumnsComponent,
    AccordionHeadlineComponent,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
    },
    crews: {
      type: Array,
    },
  },
  data() {
    return {
      active: null,
      crewActive: null,
      crewScroll: 0,
      replieScroll: 0,
      skillMaxWidth: 1,
      questionnaireMaxWidth: 1,
      totalColumn: 0,
      totalColumnArray: [],
      crewTitleHeight: [],
    };
  },
  mounted() {
    this.getCrewTitleHeight();
  },
  methods: {
    manage(payload) {
      this.$emit("manage", payload);
    },

    getCrewTitleHeight() {
      const crewDivTitle = document.getElementsByClassName("dashboard__crew__title");
      crewDivTitle.forEach((element) => {
        this.crewTitleHeight.push(element.offsetHeight);
      });
    },
    formatDate(date) {
      return dateFormatter.format(date, "short");
    },

    dashboard(id) {
      this.goDashboard(id, this.$route.params.trainingCourseId);
    },

    ...mapActions(useTriadStore, {
      goDashboard: "goDashboard",
    }),
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  overflow: scroll;
  height: auto;
  margin-left: 260px;
  border-radius: 6px;

  &__form {
    position: absolute;
    top: 260px;
    left: 20px;
    width: 250px;
  }

  &__crews {
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    width: 250px;
    position: absolute;
    height: fit-content;
    left: 20px;
    z-index: 5;

    @include mobile {
      width: 230px;
    }
  }

  &__replies__wrapper {
    width: fit-content;
    overflow: scroll;
    height: 100%;
    display: flex;
  }

  &__replies {
    display: flex;
    height: fit-content;

    &__item {
      margin-right: 10px;
      min-width: 130px;
      overflow: hidden;
      transition: all 300ms ease-in-out;

      &:last-child {
        margin-right: 0;
      }

      &.on {
        min-width: 150px;
      }

      &.-skill {
        &.on {
          min-width: 175px;
        }
      }
    }

    &__questionnaires {
      display: flex;
      width: fit-content;
    }
  }
}

.offset {
  height: 40px;
}
</style>
